import React, { VFC } from 'react';
import * as Yup from 'yup';
import { FormikProps } from 'formik';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { JourneyForm, JourneyFormik } from 'src/common/JourneyFormik';
import { FormikCheckbox } from 'src/common/form/formik/checkbox';
import { useCurrentOrganization } from 'src/store/organization';

interface DashboardSettingsMembersInviteFormProps {
  onSubmit: (values: Record<string, string>) => void;
}

export const DashboardSettingsMembersInviteForm: VFC<DashboardSettingsMembersInviteFormProps> = ({ onSubmit }) => {
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  // TODO: @anilsevim - this is a small addition / hack for savanta org. consult with @anilsevim
  const showInviteResetPasswordEmail = currentOrganization?.feature_flags.show_invite_reset_password_email;

  const formikParams = {
    initialValues: { email: '', auto_add: false },
    validationSchema: Yup.object({ email: Yup.string().email('Invalid email address').required('Required') }),
    onSubmit,
  };

  return (
    <JourneyFormik {...formikParams}>
      {({ values, errors }: FormikProps<any>) => {
        return (
          <JourneyForm>
            <div className='flex flex-col space-y-4'>
              <p className='text-bedrock-p text-bedrock-black'>
                Enter the email address for this member and an invitation will be sent to them. You will also be able to
                copy the invitation URL if you need.
              </p>
              <p className='text-bedrock-p text-bedrock-black'>
                <span className='text-bedrock-p-strong text-bedrock-red'>Notice:</span> Please note that upon acceptance
                of the invitation, the individual will be enrolled in the organization and subject to billing, if you
                have monthly or yearly subscription plan.
              </p>
              <FormikTextInput
                id='invite-member'
                name='email'
                required
                type='text'
                placeholder='Email address of new member'
              />
              {showInviteResetPasswordEmail && (
                <FormikCheckbox
                  id='auto_add'
                  name='auto_add'
                  label='Send reset password email'
                  labelClasses='font-normal text-secondary'
                  isBedrock={true}
                />
              )}
              <button
                type='submit'
                className='btn-bedrock-primary'
                disabled={values.email === '' || Object.keys(errors).length > 0}
              >
                Invite new member
              </button>
            </div>
          </JourneyForm>
        );
      }}
    </JourneyFormik>
  );
};
